import { render, staticRenderFns } from "./AppPricing.vue?vue&type=template&id=24a694c6&scoped=true&"
import script from "./AppPricing.vue?vue&type=script&lang=js&"
export * from "./AppPricing.vue?vue&type=script&lang=js&"
import style0 from "./AppPricing.vue?vue&type=style&index=0&id=24a694c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a694c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PricingCards: require('/opt/build/repo/components/elements/PricingCards.vue').default})
